import { useQuery } from '@tanstack/react-query';

import { makeRequest } from '@app/utils';

export interface LocationDto {
  id: string;
  name: string;
  code: string;
  isActive: boolean;
  institutionId: string;
  campusId: string;
  libraryId: string;
  primaryServicePoint: string;
  discoveryDisplayName?: string;
}

export interface LocationsDto {
  locations: LocationDto[];
}

const locationsFetchLimit = 1000;

export const useLocationsFetch = () =>
  useQuery<LocationsDto, unknown, LocationsDto['locations']>(
    ['locations'],
    () =>
      makeRequest<LocationsDto>({
        url: '/opac-inventory/locations',
        params: { limit: locationsFetchLimit },
      }),
    {
      refetchOnMount: false,
      select: ({ locations }) => locations,
    }
  );
